<script setup>
/* eslint-disable */
import { onMounted, computed, ref, onBeforeMount } from 'vue';
import { useBannersStore } from '@/stores/banners';
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import '@splidejs/vue-splide/css';
import { useCustomerStore } from '@/stores/customer';
import { useRouter } from 'vue-router';
import { usePlatformConfigurationStore } from '@/stores/platform_configuration';

// Define Stores
const bannersStore = useBannersStore();
const customerStore = useCustomerStore();
const is_rtl = ref(null);
const router = useRouter();
const platformConfigurationStore = usePlatformConfigurationStore();
const is_compact_banners_enabled = ref(false);

const goToPage = ((url) => {
	if (url.startsWith(process.env.VUE_APP_URL)) {
		const sliced = url.slice(process.env.VUE_APP_URL.length);
		router.push({'path': sliced});
		return;
	}

	window.location.href = url;
});


const hasBanners = computed(() => {
	return bannersStore.homepage_banners.length > 0;
});

const onSlideClick = (slide) => {
	if (!bannersStore.is_button_visible(slide.id) && slide.button_url) goToPage(slide.button_url);
}

onBeforeMount(() => {
	is_compact_banners_enabled.value = platformConfigurationStore.isCompactHeroBannersEnabled;
})

onMounted(() => {
	is_rtl.value = document.documentElement.getAttribute('dir') === 'rtl';
})
</script>

<template>
	<section :class="{ 'compact-styles': is_compact_banners_enabled, 'home_banner-mini': usePlatformConfigurationStore().hasSmallMobileCasinoBanners }">
		<div class="banner-full">
			<div  class="slider" :class="{'mobile-notification': customerStore.customerGeneralPlatformNotifications.length > 0, 'slider-mini': usePlatformConfigurationStore().hasSmallMobileCasinoBanners }">
				<div v-if="hasBanners" class="slides">
					<Splide :options="{perPage: 1, drag:true, arrows:false, pagination:true, autoplay:true, interval:5000, type:'loop', direction: is_rtl ? 'rtl' : 'ltr'}">
						<SplideSlide v-for="slide in bannersStore.homepage_banners" :key="slide.id">
							<div class="slide carousel__item" :class="{ 'is-clickable': !bannersStore.is_button_visible(slide.id) && slide.button_url }" @click="onSlideClick(slide)">
								<div class="banner-main-image">
									<img :src="slide.media_url" alt="Image 1">
								</div>
								<div class="banner-content" id="banner-item">
									<h1>{{ slide.title }}</h1>
									<h5>{{ slide.sub_title }}</h5>
									<div v-if="bannersStore.is_button_visible(slide.id)" class="banner-btn">
										<a v-if="slide.button_url" @click="goToPage(slide.button_url)" class="btn bc-btn-lg btn-secondary">{{ slide.button_text }}</a>
									</div>
								</div>
							</div>
						</SplideSlide>
					</Splide>
				</div>
			</div>
		</div>
	</section>
</template>
<style scoped>

html[dir="rtl"] .slider .slides .slide .banner-main-image img {
	width:100%
}

.is-clickable {
	cursor: pointer;
}

@media screen and (min-width: 768px) and (max-width: 3000px) {
	html[dir="rtl"] .banner-content {
		text-align:right;
	}
}
html[dir="rtl"] .slider  :deep(.splide__pagination) {
	width: 50%;
}

@media screen and (min-width: 320px) and (max-width: 767px) {
	.banner-content .banner-btn {
		position: relative;
		font-weight: 400;
		text-align: left;
		margin-top: 12px;
	}

	.banner-content:has(a) h5 {
		width: 80%;
	}

	.slider {
		padding-left: 12px;
		padding-right: 12px;
		padding-top: 65px;
	}

	.banner-content {
		padding-left: 10px;
	}

	.slider .slides .slide .banner-main-image:before {
		border-radius: 5px;
	}

	.slider .slides .slide .banner-main-image img {
		border-radius: 5px;
	}

	.home_banner-mini {
		padding-top: 50px;
	}

	.home_banner-mini .banner-full .slider {
		padding-top: 0px;
	}
}
@media screen and (max-width: 767px) {
	.mobile-notification {
		padding-top: unset;
	}
}

@media screen and (min-width: 768px) and (max-width: 991px) {
	.mobile-notification {
		padding-top: unset;
	}
}

/* These styles will only apply if is_compact_banners_enabled is true */
@media screen and (min-width: 800px) {
	.compact-styles .slider {
		height: 65vh;
		min-height: 500px;
		max-height: 700px;
	}
}

html[dir=rtl] .compact-styles .slider .slides .slide .banner-main-image:before {
	transform:none;
}

.compact-styles .slider .slides .slide .banner-main-image:before{
	background: none;
}

.compact-styles .slider .slides .splide .splide__track:after,
.compact-styles .slider .slides .splide .splide__track:before{
	background-image: none;
}

.compact-styles .slider .slides .splide :deep(.splide__track:before) {
	background-image: unset;
}

.compact-styles .slider .slides .splide :deep(.splide__track:after) {
	background-image: unset;
}

html[dir=rtl] .compact-styles .slider :deep(.splide__pagination) {
	left: unset;
	right: -8%;
}

.compact-styles .slider :deep(.splide__pagination) {
	bottom: 29.4%;
}

@media screen and (max-width: 1170px) {
	.compact-styles .slider :deep(.splide__pagination) {
		display: none;
	}


}
/* End of is_compact_banners_enabled Styles */
</style>